import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import configInfo from '../config/config.json';
import TemplateListView    from "./TemplateListView";
import DeptAdminDetailsView from "./DeptAdminDetailsView";
import DeptAdminNewView     from "./DeptAdminNewView";


const DeptAdmin = () => {

  const { i18n, t } = useTranslation(["common","custom"]);
  const { user }    = useContext(UserContext);
  const navigate    = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "DeptAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["UserAdminWriteAccess", "OrgAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Dept_code"),
      sortable: true,
      sortField: 'deptCode',
      grow: 2.0,
      cell: null
    },
    {
      name: t("I18N_Dept_name"),
      selector: row => row.name,
      cell: row => row.name,
      grow: 2.0,
      sortable: true,
      sortField: 'name'
    },
    {
      name: <div style={{ whiteSpace: 'normal' }}>{t("I18N_Dept_name") + " (" + t("custom:I18N_Language_2") + ")"}</div>,
      selector: row => row.nameLang2,
/* Sorting Chinese support for database is not reliable
      sortable: true,
      sortField: 'nameLang2',
*/
      omit: !configInfo.uiConfig.visibleFields.DEPT_NameLang2
    },
    {
      name: <div style={{ whiteSpace: 'normal' }}>{t("I18N_Dept_name") + " (" + t("custom:I18N_Language_3")+ ")"}</div>,
      selector: row => row.nameLang3,
/* Sorting Chinese support for database is not reliable
      sortable: true,
      sortField: 'nameLang3',
*/
      wrap: true,
      omit: !configInfo.uiConfig.visibleFields.DEPT_NameLang3
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Parent_dept_code"),
      selector: row => row.parentDisplayName[i18n.language],
      sortable: true,
      sortField: 'parentDept'
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  const objListPostProcessing = (objList) => {

    for (let i=0; i<objList.length; i++) {
      objList[i].code = objList[i].deptCode;

      objList[i].parentDisplayName = [];
      objList[i].parentDisplayName['en']    = objList[i].parentDeptId ? objList[i].parentDeptName      : t("I18N_No_parent_dept", { lng: 'en' });
      objList[i].parentDisplayName['zh_HK'] = objList[i].parentDeptId ? objList[i].parentDeptNameLang2 : t("I18N_No_parent_dept", { lng: 'zh_HK' });
      objList[i].parentDisplayName['zh_CN'] = objList[i].parentDeptId ? objList[i].parentDeptNameLang3 : t("I18N_No_parent_dept", { lng: 'zh_CN' });
    }

    return (objList);
  }

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_IDENT_MGMT_API}
                                                  apiObjName={'departments'}
                                                  listPageTitle={t("I18N_Dept_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_dept")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Dept_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_dept")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  objListPostProcessing={objListPostProcessing}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <DeptAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <DeptAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default DeptAdmin;
